module.exports = __webpack_public_path__ + "media/images/country_flags/jo-33f4bc3ef0f4fa63bbd0a44295cea5f3.png";